import React, { useState } from 'react';
import classnames from 'classnames';
import BillingStatusBadge from 'components/v2/BillingStatusBadge';
import RefreshIcon from 'components/v2/icons/RefreshIcon';
import Tooltip from 'components/ui/Tooltip';
import usePoller from 'hooks/usePoller';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import {
  evaluateBillingStatus,
  refreshOrderBillingStatus,
} from 'utils/ShipmentWebAPIUtils';
import { useTranslation } from 'react-i18next';

export default function BillingStatus({
  shipment,
  order,
  isOrderContext,
  onRefreshSuccess,
}) {
  const { t } = useTranslation();
  if (!isIntermodalShipmentType(shipment) && !isOrderContext) {
    return null;
  }

  const [disabled, setDisabled] = useState(false);
  const { resetTimer } = usePoller(() => setDisabled(false));

  const handleClick = async () => {
    if (disabled) return;

    try {
      if (isOrderContext && order?._id) {
        await refreshOrderBillingStatus(order._id);
        if (onRefreshSuccess) {
          onRefreshSuccess();
        }
      } else {
        const shipmentId = shipment?._id ?? shipment;
        if (shipmentId) {
          await evaluateBillingStatus([shipmentId]);
        }
      }
    } catch (error) {
      console.error('Failed to refresh billing status:', error);
    }

    setDisabled(true);
    resetTimer();
  };

  let billingStatus =
    shipment?.billing_status ??
    order?.order_billing_status_state?.billing_status;

  if (!billingStatus) {
    return null;
  }
  const renderIcon = () => {
    const tooltip = disabled
      ? 'BILLING_STATUS_REFRESH_DISABLED'
      : 'BILLING_STATUS_REFRESH_ENABLED';
    return (
      <Tooltip
        dataTestId="Tooltip-1dd2065b"
        id="tooltip-master-ref"
        content={t(tooltip)}
        position="top"
      >
        <div
          data-testid="div-dc6979d4"
          className="my-auto"
          onClick={handleClick}
        >
          <RefreshIcon
            className={classnames({ disabled, 'w-4': true, 'h-4': true })}
          />
        </div>
      </Tooltip>
    );
  };

  return (
    <div data-testid="div-c1280eb9" className="flex">
      <BillingStatusBadge
        className={isOrderContext ? '' : 'mx-2'}
        billingStatus={billingStatus}
      />
      {renderIcon()}
    </div>
  );
}
